export function placeholder() {
	if(!Modernizr.input.placeholder){
		$('[placeholder]').focus(function() {
			let input = $(this);
			if (input.val() == input.attr('placeholder')) {
				input.val('');
				input.removeClass('ph');
			}
		}).blur(function() {
			let input = $(this);
			if (input.val() === '' || input.val() == input.attr('placeholder')) {
				input.addClass('ph');
				input.val(input.attr('placeholder'));
			}
		}).blur();
		$('[placeholder]').parents('form').submit(function() {
			$(this).find('[placeholder]').each(function() {
				let input = $(this);
				if (input.val() == input.attr('placeholder')) {
					input.val('');
				}
			});
		});
	}
}

export function title() {
	$('[title]').each(function(){
		$(this).data('original-title', $(this).attr('title'));
	}).hover(function () {
		$(this).attr('title','');
	}, function () {
		$(this).attr('title',$(this).data('original-title'));
	});
}

export function buttonTarget() {
	$('button[data-href]').click( function( e ){
		let target = $(e.target);
		if ( target.not( 'a' )) {
			e.preventDefault();
			if ( $( this ).attr( 'data-window' ) == 'new' ) {
				window.open( $( this ).attr( 'data-href' ) );
			} else {
				window.location.href = $( this ).attr( 'data-href' );
			}
			return false;
		}
	});
}

export function init() {
	placeholder();
	title();
	buttonTarget();
}
